import { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

/**
* Renders a skeleton UI for a stats card using the current theme context.
* @example
* StatsCardSkeleton()
* <div className="rounded-lg p-6">...</div>
* @param {void} void - This component does not accept props.
* @returns {JSX.Element} Placeholder skeleton layout for stats cards.
**/
const StatsCardSkeleton = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div 
      className="rounded-lg p-6"
      style={{ 
        backgroundColor: theme.background.card,
        boxShadow: theme.shadow.md
      }}
    >
      {/* 2-column layout: Circle left, Stats right */}
      <div className="grid grid-cols-[280px_1fr] gap-6">
        {/* LEFT: Circle */}
        <div className="flex flex-col items-center justify-center">
          <div 
            className="size-[200px] rounded-full animate-pulse"
            style={{ backgroundColor: theme.background.secondary }}
          />
          <div 
            className="h-4 rounded w-16 mt-3 animate-pulse"
            style={{ backgroundColor: theme.background.secondary }}
          />
        </div>

        {/* RIGHT: Vertical Stats - 3 Cards */}
        <div className="flex flex-col gap-3">
          {[1, 2, 3].map(i => (
            <div 
              key={i}
              className="p-4 rounded-lg border"
              style={{ 
                backgroundColor: theme.background.secondary,
                borderColor: theme.border.primary
              }}
            >
              <div 
                className="h-4 rounded w-12 mx-auto mb-2 animate-pulse"
                style={{ backgroundColor: theme.background.primary }}
              />
              <div 
                className="h-8 rounded w-24 mx-auto animate-pulse"
                style={{ backgroundColor: theme.background.primary }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsCardSkeleton;
